import { ArrayValue, RecordValue } from '@coveo/bueno';
import { createAction } from '@reduxjs/toolkit';
import { requiredEmptyAllowedString, validatePayload, } from '../../utils/validate-payload.js';
export const setContext = createAction('dictionaryFieldContext/set', (payload) => {
    const objSchema = new RecordValue({ options: { required: true } });
    const objError = validatePayload(payload, objSchema).error;
    if (objError) {
        return { payload, error: objError };
    }
    const values = Object.values(payload);
    const valueSchema = new ArrayValue({ each: requiredEmptyAllowedString });
    const valuesError = validatePayload(values, valueSchema).error;
    if (valuesError) {
        return { payload, error: valuesError };
    }
    return { payload };
});
export const addContext = createAction('dictionaryFieldContext/add', (payload) => {
    const schema = new RecordValue({
        options: { required: true },
        values: {
            field: requiredEmptyAllowedString,
            key: requiredEmptyAllowedString,
        },
    });
    return validatePayload(payload, schema);
});
export const removeContext = createAction('dictionaryFieldContext/remove', (payload) => {
    return validatePayload(payload, requiredEmptyAllowedString);
});
